<template>
  <v-flex
    id="instruction"
    class="question"
  >
    <p><span class="sz_red--text">*</span> {{ $t('sheet.fields_required') }}</p>
    <h2 class="header">
      {{ $t('sheet.sheetOne.meeting.instruction.title') }}
    </h2>
    <div class="content">
      <p>
        {{ $t('sheet.sheetOne.meeting.instruction.text_1') }}
        <br>
        {{ $t('sheet.sheetOne.meeting.instruction.text_2') }}
        <a
          target="_blank"
          :disabled="!isCurrentEdition"
          :href="links.FILL_INSTRUCTION_COURSE"
        >{{
          $t('sheet.sheetOne.meeting.instruction.link_1')
        }}</a>
        {{ $t('sheet.sheetOne.meeting.instruction.text_3') }}
      </p>
      <p>
        {{ $t('sheet.sheetOne.meeting.instruction.text_4') }}
        <a
          :disabled="!isCurrentEdition || readOnly"
          @click="dialog = !readOnly"
        >{{
          $t('sheet.sheetOne.meeting.instruction.link_2')
        }}</a>.
      </p>
      <div class="alert-box pa-3">
        <p
          v-for="(text, index) in $t('sheet.sheetOne.meeting.instruction.alert')"
          :key="index"
          class="mb-0"
        >
          {{ text }}
        </p>
      </div>
    </div>
    <turnOffModal
      :visible="dialog"
      :family-id="familyId"
      :reasons-id="2"
      @close="dialog = false"
      @reload="goToCard()"
    />
  </v-flex>
</template>

<script>
import turnOffModal from '@/components/familyCard/TurnOffModal';
import links from '@/constants/links';

export default {
    name: 'FillInstruction',
    components: {
        turnOffModal
    },
    props: {
        readOnly: {
            default: false,
            type: Boolean
        }
    },
    data () {
        return {
            dialog: false,
            links
        };
    },
    computed: {
        familyId () {
            return this.$route.params.familyId;
        },
        isCurrentEdition () {
            return this.$store.getters['family/isCurrentEdition'];
        }
    },
    methods: {
        goToCard () {
            this.$router.push({ name: 'family-card', params: { id: this.familyId } });
        }
    }
};
</script>

<style lang="scss" scoped></style>
